import { PurchaseMethods } from '@sm360/widget-commons-vehicle';

import * as ModelService from 'catalog/services/ModelService.js';

const { PurchaseMethodsValues, PurchaseMethodsConstant } = PurchaseMethods;

export function filterBodyStyles(manufacturer, selectedBodyStyleCodes) {
    return manufacturer.set(
        'models',
        manufacturer.models.map((model) => ModelService.resetModelBodyStylesFilter(model, selectedBodyStyleCodes))
    );
}

export function filterMake(manufacturer, make) {
    return manufacturer.set(
        'models',
        manufacturer.models.map((model) => ModelService.resetModelMakeFilter(model, make))
    );
}

export function filterModel(manufacturer, modelSearchString) {
    return manufacturer.set(
        'models',
        manufacturer.models.map((model) => ModelService.resetModelStringFilter(model, modelSearchString))
    );
}

function resetModelPurchaseMethod(model, purchaseMethod) {
    let selectedPurchaseMethod = PurchaseMethodsConstant.BEST_PAYMENT;
    switch (purchaseMethod.value) {
        case PurchaseMethodsValues.LEASE:
            selectedPurchaseMethod = PurchaseMethodsConstant.LEASE;
            break;

        case PurchaseMethodsValues.FINANCE:
            selectedPurchaseMethod = PurchaseMethodsConstant.FINANCE;
            break;

        case PurchaseMethodsValues.FINANCE | PurchaseMethodsValues.LEASE:
            selectedPurchaseMethod = PurchaseMethodsConstant.BEST_PAYMENT;
            break;

        default:
            break;
    }

    return model.set(
        'purchaseMethods',
        PurchaseMethods.PurchaseMethodsService.selectPurchaseMethod(
            model.get('purchaseMethods'),
            selectedPurchaseMethod
        )
    );
}

function resetModelPaymentFrequency(model, paymentFrequency) {
    return model.set(
        'purchaseMethods',
        PurchaseMethods.PurchaseMethodsService.selectPaymentFrequency(model.get('purchaseMethods'), paymentFrequency)
    );
}

function resetModelTradeIn(model, tradeIn) {
    return model.set(
        'purchaseMethods',
        PurchaseMethods.PurchaseMethodsService.setTradeIn(model.purchaseMethods, tradeIn)
    );
}

function resetModelLien(model, lien) {
    return model.set('purchaseMethods', PurchaseMethods.PurchaseMethodsService.setLien(model.purchaseMethods, lien));
}

export function selectPurchaseMethod(manufacturer, purchaseMethod) {
    const models = manufacturer.get('models').map((model) => resetModelPurchaseMethod(model, purchaseMethod));

    return manufacturer.set(
        'models',
        models.sortBy((model) => model.get('purchaseMethods').getOrderValue(purchaseMethod.value))
    );
}

export function selectPaymentFrequency(manufacturer, paymentFrequency) {
    return manufacturer.set(
        'models',
        manufacturer.get('models').map((model) => resetModelPaymentFrequency(model, paymentFrequency))
    );
}

export function setTradeIn(manufacturer, tradeIn) {
    return manufacturer.set('models', manufacturer.models.map((model) => resetModelTradeIn(model, tradeIn)));
}

export function setLien(manufacturer, lien) {
    return manufacturer.set('models', manufacturer.models.map((model) => resetModelLien(model, lien)));
}
